import React from 'react';
import Header from './Header';
import '../css/Layout.css';
import { Outlet } from 'react-router-dom';

const Layout = ({ children }) => {
  return (
    <div className="layout">
      <Header />
      <div className="main">
        <div className="content">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Layout;
